// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"a415cead","37":"040dc342","48":"662de92a","96":"ff810b21","352":"5f3049a6","369":"b9a36ec8","439":"e3dce507","455":"bce70fe4","479":"c188e04f","873":"da0104c2"}[chunkId] + ".chunk.js";
};